import { TakingCommands, TakingSubmitData, getQuestionFieldId } from "@teams/cards";
import { OrdinalQuestion, TeamsSurveyResponse } from "@teams/types";
import { SurveyDTO } from "@teams/types/api";
import React from "react";

import { useUserInfo } from "../../../../../_shared/actions/useUserInfo";
import { isError } from "../../../../../_shared/services/ChannelApi";
import { surveyApi } from "../../../../../_shared/services/SurveyApi";
import { useTeamsContext } from "../../../../../_shared/state/TeamsContextProvider";
import { HotTakeVoteButtons, HotTakeVoteType } from "./HotTakeVoteButton";

type Props = {
  survey: SurveyDTO;
  surveyResponses: TeamsSurveyResponse[];
  trackingSource: string;
};

export const HotTakeAnswerForm: React.FC<Props> = ({ survey, surveyResponses, trackingSource }) => {
  const { teamsContext } = useTeamsContext();
  const { user } = useUserInfo();

  const question = survey.questions[0] as OrdinalQuestion;
  const choices = question.choices;

  async function save(vote: HotTakeVoteType) {
    const body: TakingSubmitData = {
      command: TakingCommands.Submit,
      surveyId: survey.id as string,
      questionIndexId: survey.questions[0].id,
      questionIds: survey.questions.map(q => q.id),
      direction: "next",
      startDate: new Date().toISOString(),
      responseAnonymity: "none",
    };

    body[getQuestionFieldId(survey.questions[0].id)] =
      vote === "up" ? choices[0].id : choices[1].id;

    const result = await surveyApi.vote(teamsContext, survey.id as string, body, trackingSource);
    if (isError(result)) {
      console.error(result);
      return [result];
    }
  }

  let selected: HotTakeVoteType | undefined;
  const userResponse = surveyResponses.find(r => r.user.aadObjectId === user.userId);
  if (userResponse) {
    selected = userResponse.responses[0].value === choices[0].id ? "up" : "down";
  }

  return (
    <HotTakeVoteButtons
      disabled={survey.state !== "open"}
      onClick={vote => save(vote)}
      selected={selected}
    />
  );
};
